import { useSuspenseQuery } from '@tanstack/react-query'

import { contractQueries, ZMasterContractStatus } from '@/entities/contract'
import { Dashboard, formatThumbnailsForDisplay } from '@/widgets/dashboard'

type Props = {
  className?: string
}

export const ContractStatus = ({ className }: Props) => {
  const {
    data: contractStatusCount,
    refetch: refetchContractStatusCount,
    isFetching: isFetchingContractStatusCount,
  } = useSuspenseQuery({
    ...contractQueries.hostContractStatusCount(),
    meta: {
      useCustomHandling: true,
    },
  })

  const {
    reviewingCount,
    readyCount,
    activeCount,
    terminatingCount,
    currentTime: contractStatusCountTime,
    reviewingContractRoomPics,
    readyContractRoomPics,
    activeContractRoomPics,
    terminatingContractRoomPics,
  } = contractStatusCount

  const reviewingThumbnails = formatThumbnailsForDisplay(
    reviewingContractRoomPics,
    reviewingCount,
  )
  const readyThumbnails = formatThumbnailsForDisplay(
    readyContractRoomPics,
    readyCount,
  )
  const activeThumbnails = formatThumbnailsForDisplay(
    activeContractRoomPics,
    activeCount,
  )
  const terminatingThumbnails = formatThumbnailsForDisplay(
    terminatingContractRoomPics,
    terminatingCount,
  )

  return (
    <Dashboard.Card className={className}>
      <Dashboard.Header>
        <Dashboard.Title>계약 현황</Dashboard.Title>
        <Dashboard.Refresh
          time={contractStatusCountTime}
          onRefresh={refetchContractStatusCount}
          isRefreshing={isFetchingContractStatusCount}
        />
      </Dashboard.Header>
      <Dashboard.Content columns={4} className="gap-3">
        <Dashboard.ContractItem
          title="계약대기"
          href={`/host/contract?status=${ZMasterContractStatus.Enum.REVIEWING}`}
          count={reviewingCount}
          thumbnails={reviewingThumbnails}
        />
        <Dashboard.ContractItem
          title="입주대기"
          href={`/host/contract?status=${ZMasterContractStatus.Enum.READY}`}
          count={readyCount}
          thumbnails={readyThumbnails}
        />
        <Dashboard.ContractItem
          title="거주중"
          href={`/host/contract?status=${ZMasterContractStatus.Enum.ACTIVE}`}
          count={activeCount}
          thumbnails={activeThumbnails}
        />
        <Dashboard.ContractItem
          title="퇴실중"
          href={`/host/contract?status=${ZMasterContractStatus.Enum.TERMINATING}`}
          count={terminatingCount}
          thumbnails={terminatingThumbnails}
        />
      </Dashboard.Content>
    </Dashboard.Card>
  )
}
